import env from '../env';
import BaseService from './BaseService';
const url = `${env.health_backend}health/notes`;

class NotesService extends BaseService{};

export default new NotesService('health_backend','health/notes');